import overArg from "./component-library410.mjs";
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
export {
  getPrototype$1 as default
};
